import { CheckPermissionsModes } from "@elit-hair/elit-tools";
import { TbCalendar, TbCalendarEvent, TbCalendarTime, TbCalendarUser } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const calendarRoutes: NavigationRoute[] = [
    {
        meta: {
            label: "calendar",
            order: 5,
            icon: TbCalendar,
            visibleInSidebar: true,
            // Any of the children's permissions, so the section shows whenever one of its pages does.
            permissions: [
                PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE,
                PERMISSIONS.CALL_SVC_ADMIN_BASE,
                PERMISSIONS.CALL_SCHEDULE_READ,
            ],
            permissionMode: CheckPermissionsModes.ANY,
        },
        children: [
            {
                to: APP_ROUTES_TO.EVENTS,
                meta: {
                    label: "events",
                    order: 1,
                    icon: TbCalendarEvent,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
            {
                to: APP_ROUTES_TO.MANAGEMENT_SCHEDULES,
                meta: {
                    label: "user_schedules",
                    order: 2,
                    icon: TbCalendarTime,
                    visibleInSidebar: true,
                    // Same code call-svc requires to read schedules.
                    permissions: [PERMISSIONS.CALL_SCHEDULE_READ],
                },
            },
            {
                to: APP_ROUTES_TO.CALENDAR_APPOINTMENTS,
                meta: {
                    label: "appointment_management",
                    order: 3,
                    icon: TbCalendarUser,
                    visibleInSidebar: true,
                    permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
                    permissionMode: CheckPermissionsModes.ANY,
                },
            },
        ],
    },
];
